import styled from "styled-components";

export const ComparisonForm = styled.form`
    display: flex;
    flex-direction: column;
    max-width: unset !important;
    margin-bottom: 16px;

    fieldset, label
    {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding: 0;
        margin: 0;
        border: none;
    }

    label
    {
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 16px;
        margin-top: 8px;
    }

    input, textarea
    {
        margin-top: 6px;
        font-size: 16px;
        border-radius: 6px;
        padding: 10px 12px;
        border: 1px solid var(--color-primary-desat);
        transition: all .25s;

        &:focus, &:active, &:focus-visible
        {
            border: 1px solid var(--color-primary-dark) !important;
        }
    }
`;

export const VerticalRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-bottom: 16px;

    & > *
    {
        flex: 1;
    }
`;
